import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class detailService {
  baseUrl: string = environment.cloudUrl;
  idUrl: string = this.baseUrl + 'order';
  constructor(private http: HttpClient) {}

  getById(id): Observable<any> {
    let url = `${this.idUrl}/${id}`;
    return this.http.get(url).pipe(
      map((data) => {
        return data;
      })
    );
  }
  //   getList(): Observable<any> {
  //     const url = this.listUrl;
  //     return this.http.get(url).pipe(
  //       map((data) => {
  //         return data;
  //       })
  //     );
  //   }

  downloadFile(data, filename = 'data') {
    let exportData = [];
    if (data === undefined) {
      return;
    }
    data.forEach((element, i) => {
      let obj = {};
      obj['IMPA CODE'] =
        element.partNumber == undefined
          ? '-'
          : '"=""' + element.partNumber + '"""';
      obj["OWNER'S CODE"] =
        element.ownerCode == undefined ? '-' : element.ownerCode;
      // obj['DESCRIPTION'] =
      //   element.description2 == null
      //     ? element.description1
      //     : element.description1 + element.description2;
          obj['DESCRIPTION'] = element.catalogueType == 3 ? 
          element.description2 == null
          ? element.description1
          : element.description1 +' ' + element.description2 :
            element.description2 == null
              ? element.description1
              : element.description1 + element.description2;
      obj['QUANTITY'] = element.quantity;
      obj['UOM'] = element.uom == undefined ? '-' : element.uom;
      obj['REMARK'] =
        element.remark == undefined || element.remark == null
          ? '-'
          : element.remark;
      obj['DEPARTMENT'] =
        element.department == undefined ? '-' : element.department;
      exportData.push(obj);
    });
    let csvData = this.ConvertToCSV(exportData, [
      'IMPA CODE',
      "OWNER'S CODE",
      'DESCRIPTION',
      'QUANTITY',
      'UOM',
      'REMARK',
      'DEPARTMENT',
    ]);
    console.log(csvData);
    let blob = new Blob(['\ufeff' + csvData], {
      type: 'text/csv;charset=utf-8;',
    });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    let isSafariBrowser =
      navigator.userAgent.indexOf('Safari') != -1 &&
      navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {
      //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'display';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S.No,';

    for (let index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = i + 1 + '';
      for (let index in headerList) {
        let head = headerList[index];

        line += ',' + array[i][head];
      }
      str += line + '\r\n';
    }
    return str;
  }
}
